import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { isEmpty } from '../../../common/functions';
import { InsectaServiceBase } from '../insecta.base.service';
import { IVendor } from '../insecta.models';

@Injectable({
  providedIn: 'root'
})
export class VendorAdminService extends InsectaServiceBase {
  public addVendor(vendor: IVendor): Observable<string> {
    return this.post<string>(`/admin/vendors`, `v1`, {
      name: vendor.name,
      isActive: vendor.isActive,
      username: vendor.actionBy
    });
  }

  public getVendor(id: string): Observable<IVendor> {
    return this.get<IVendor>(`/admin/vendors/${id}`, 'v1');
  }

  public getVendors(includeInActive: boolean | null | undefined): Observable<IVendor[]> {
    if (isEmpty(includeInActive)) includeInActive = false;

    return this.get<IVendor[]>(`/admin/vendors`, 'v1').pipe(
      map((results) => [...results].filter((x: IVendor) => includeInActive || x.isActive)),
      map((results) =>
        [...results].sort((a: IVendor, b: IVendor) => (a.isActive == b.isActive ? (a.name > b.name ? 1 : -1) : a.isActive < b.isActive ? 1 : -1))
      )
    );
  }

  public getVendorsAll(): Observable<IVendor[]> {
    return this.getVendors(true);
  }

  public updateVendor(vendor: IVendor): Observable<any> {
    return this.put<IVendor>(`/admin/vendors/${vendor.id}`, `v1`, {
      id: vendor.id,
      name: vendor.name,
      isActive: vendor.isActive,
      username: vendor.actionBy
    });
  }
}
